import React from 'react'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'

import { NavBar } from 'antd-mobile'
import PropTypes from 'prop-types'

import { links } from 'components/Layout/Sidebar/Components/Menu/links'

import DropdownMobile from './Components/Dropdown'
import UserProfile from './Components/UserProfileMenu'

function MobileView({ showUserProfile = true, headerTitle = null, user }) {
  const { pathname } = useLocation()
  const intl = useIntl()

  const mobileMainRoutes = (function flatten(list, parentLabel, parentIcon) {
    return list.reduce((acc, obj) => {
      const { children, label = parentLabel, icon = parentIcon, ...rest } = obj
      acc.push({ ...rest, label, icon })
      if (children) {
        // eslint-disable-next-line no-param-reassign
        acc = acc.concat(flatten(children, label, icon))
      }
      return acc
    }, [])
  })(links)

  const storageHeaderTitle = localStorage.getItem('headerTitle')
  const intlHeaderTitle =
    mobileMainRoutes.find(menuItem => menuItem.to.pathname === pathname)
      ?.label ||
    storageHeaderTitle ||
    headerTitle

  return mobileMainRoutes.find(menuItem => menuItem.to.pathname === pathname)
    ?.id === 'home' ? null : (
    <NavBar
      back={null}
      left={<DropdownMobile />}
      right={showUserProfile && <UserProfile user={user} />}
      style={{ color: '#f5f5f5', background: 'var(--adm-color-primary)' }}
    >
      {intlHeaderTitle &&
        intl.formatMessage({
          id: intlHeaderTitle,
        })}
    </NavBar>
  )
}

MobileView.propTypes = {
  showUserProfile: PropTypes.bool,
  headerTitle: PropTypes.string,
  user: PropTypes.shape({}),
}

MobileView.defaultProps = {
  showUserProfile: true,
  headerTitle: null,
  user: null,
}

export default MobileView
